import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericApiService } from 'shared/services';

@Injectable({
  providedIn: 'root'
})
export class GenericApiFactory {

  constructor(private injector: Injector) {

  }
  create<TModel, TQueryModel>(name: string) {
    return new GenericApiService<TModel, TQueryModel>(this.injector, name)
  }
}
